module.exports = __webpack_public_path__ + "static/media/FLOWVid1.875aac5d.mp4";